import {
  INITIATE_STARTUP_CREATION,
  STARTUP_CREATION_SUCCESS,
  STARTUP_CREATION_FAILURE,
  INITIATE_PUBLISH_NOW,
  PUBLISH_NOW_SUCCESS,
  PUBLISH_NOW_FAILURE,
  INITIATE_PUBLISH_PAGE_LAYOUT,
  PUBLISH_PAGE_LAYOUT_SUCCESS,
  PUBLISH_PAGE_LAYOUT_FAILURE,
  PUBLISH_MENU_LAYOUT_SUCCESS,
  PUBLISH_MENU_LAYOUT_FAILURE,
} from "../actions/types"; // Correctly importing from 'types.js'

// Initial state for the startup reducer
const initialState = {
  loading: false, // Tracks if a process (creation or publishing) is ongoing
  successMessage: null, // Stores success messages from the backend
  errorMessage: null, // Stores error messages if the process fails
};

// Startup reducer to handle state changes based on actions
const startupReducer = (state = initialState, action) => {
  switch (action.type) {
    // Handle startup creation initiation
    case INITIATE_STARTUP_CREATION:
      return {
        ...state,
        loading: true, // Set loading to true when the creation process starts
        successMessage: null, // Clear previous success messages
        errorMessage: null, // Clear previous error messages
      };

    // Handle successful startup creation
    case STARTUP_CREATION_SUCCESS:
      return {
        ...state,
        loading: false, // Set loading to false after successful creation
        successMessage: action.payload, // Store the success message
        errorMessage: null, // Clear error messages
      };

    // Handle startup creation failure
    case STARTUP_CREATION_FAILURE:
      return {
        ...state,
        loading: false, // Set loading to false after failure
        successMessage: null, // Clear success messages
        errorMessage: action.error, // Store the error message
      };

    // Handle publish initiation
    case INITIATE_PUBLISH_NOW:
      return {
        ...state,
        loading: true, // Set loading to true when the publish process starts
        successMessage: null, // Clear previous success messages
        errorMessage: null, // Clear previous error messages
      };

    // Handle successful publishing
    case PUBLISH_NOW_SUCCESS:
      return {
        ...state,
        loading: false, // Set loading to false after successful publishing
        successMessage: action.payload, // Store the success message
        errorMessage: null, // Clear error messages
      };

    // Handle publishing failure
    case PUBLISH_NOW_FAILURE:
      return {
        ...state,
        loading: false, // Set loading to false after failure
        successMessage: null, // Clear success messages
        errorMessage: action.error, // Store the error message
      };

    // Handle successful page layout publishing
    case PUBLISH_PAGE_LAYOUT_SUCCESS:
      console.log(
        `PMM - SF - startupReducer - PUBLISH_PAGE_LAYOUT_SUCCESS - action is: ${JSON.stringify(
          action
        )}`
      );

      return {
        ...state,
        loading: false, // Set loading to false after successful page layout publish
        publishPageLayoutSuccessMessage: action?.payload, // Store the success message
        errorMessage: null, // Clear error messages
      };

    // Handle page layout publishing failure
    case PUBLISH_PAGE_LAYOUT_FAILURE:
      return {
        ...state,
        loading: false, // Set loading to false after failure
        successMessage: null, // Clear success messages
        errorMessage: action.error, // Store the error message
      };

    // Handle successful menu layout publishing
    case PUBLISH_MENU_LAYOUT_SUCCESS:
      console.log(
        `PMM - startupReducer.js - PUBLISH_MENU_LAYOUT_SUCCESS case initiated - action is: ${JSON.stringify(
          action
        )}`
      );
      return {
        ...state,
        loading: false, // Set loading to false after successful menu layout publish
        publishMenuSuccessMessage: action.payload, // Store the success message
        errorMessage: null, // Clear error messages
      };

    // Handle menu layout publishing failure
    case PUBLISH_MENU_LAYOUT_FAILURE:
      return {
        ...state,
        loading: false, // Set loading to false after failure
        successMessage: null, // Clear success messages
        errorMessage: action.error, // Store the error message
      };

    // Default state if no action is matched
    default:
      return state;
  }
};

export default startupReducer;
